module.exports = __webpack_public_path__ + "img/github.e6de8f73.svg";